import c from './individual-feedback.module.scss';
import { Icon, Button, Tag } from '@monash/portal-react';
import {
  FEEDBACK_STATUS,
  PRIORITY_TAGS,
  UPDATE_FEEDBACK_STATUS,
  OPT_IN,
  BUG,
  HDR,
} from '../constants';
import ImageGallery from '../image-gallery/ImageGallery';
import FeedbackModal from '../modals/FeedbackModal';
import { useState } from 'react';

const IndividualFeedback = ({
  feedbackItem,
  setSelectedFeedback,
  selectedFeedbackId,
}) => {
  const [editFeedbackShown, setEditFeedbackShown] = useState(false);
  const regex = /ML-([0-9]{4})/;

  const handleKeyDown = (e) => {
    if (e.code === 'Enter') {
      setSelectedFeedback('');
    }
  };

  const openEditFeedback = () => {
    setEditFeedbackShown(true);
  };

  return (
    <div>
      {editFeedbackShown && (
        <FeedbackModal
          editFeedbackShown={editFeedbackShown}
          feedbackItem={feedbackItem}
          setEditFeedbackShown={setEditFeedbackShown}
        />
      )}

      <div className={c.container}>
        <div className={c.header}>
          <h1 tabIndex={-1} className={c.top}>
            <div className={c.individualHeading}>
              <div
                className={c.backArrow}
                onClick={() => setSelectedFeedback('')}
                tabIndex="0"
                onKeyDown={(e) => handleKeyDown(e)}
              >
                <Icon.ArrowLeft className={c.icon} />
              </div>
              Feedback #<div>{feedbackItem?.displayID}</div>
            </div>

            <Button variant="text">View History </Button>
          </h1>
          <p>
            Detailed view of feedback item. Please click save to keep any
            changes made.
          </p>
        </div>
        <div className={c.body}>
          <div className={c.splitView}>
            <div className={c.leftSide}>
              <div className={c.feedbackSection}>
                <label className={c.feedbackLabel}>Student details</label>
                <div className={c.attributes}>
                  <h3>Student email: </h3>
                  <a href={feedbackItem?.monashEmail}>
                    {feedbackItem?.monashEmail}
                  </a>
                </div>
                <div className={c.attributes}>
                  <h3>User-testing opt-in:</h3>
                  <div>
                    {feedbackItem?.optIn === OPT_IN.YES && 'Yes'}
                    {feedbackItem?.optIn === OPT_IN.NO && 'No'}
                  </div>
                </div>
              </div>

              <div className={c.feedbackSection}>
                <label className={c.feedbackLabel}>Feedback details</label>
                <div className={c.attributes}>
                  <h3>App: </h3>
                  <div>{feedbackItem?.app}</div>
                </div>
                <div className={c.attributes}>
                  <h3>Area: </h3>
                  <div>{feedbackItem?.area}</div>
                </div>
                <div className={c.attributes}>
                  <h3>Date recorded: </h3>
                  <div>
                    {new Date(feedbackItem?.createdAt).toLocaleString()}
                  </div>
                </div>
                <div className={c.attributes}>
                  <h3>Last edit: </h3>
                  <div>{new Date(feedbackItem?.lastEdit).toLocaleString()}</div>
                </div>
              </div>
              <div className={c.feedbackSection}>
                <label className={c.feedbackLabel}>Feedback text</label>
                <div>{feedbackItem?.replicateIssue}</div>
              </div>
              <div className={c.feedbackSection}>
                <label className={c.feedbackLabel}>Feedback attachments</label>
                <ImageGallery
                  feedbackItem={feedbackItem}
                  selectedFeedbackId={selectedFeedbackId}
                />
              </div>
            </div>
            <div className={c.rightSide}>
              <div className={c.attributeSection}>
                <div className={c.attributeTitle}>
                  <h2>Feedback attributes </h2>
                  <Button
                    size="small"
                    variant="text"
                    icon={<Icon.Pencil />}
                    onClick={() => openEditFeedback()}
                  />
                </div>
                <div className={c.attributes}>
                  <h3>Status: </h3>
                  <div>{FEEDBACK_STATUS[feedbackItem?.status]}</div>
                </div>
                <div className={c.attributes}>
                  <h3>Priority: </h3>
                  <Tag
                    text={PRIORITY_TAGS[feedbackItem?.priority]?.label}
                    color={PRIORITY_TAGS[feedbackItem?.priority]?.colour}
                  />
                </div>
                {feedbackItem?.status === UPDATE_FEEDBACK_STATUS.IN_JIRA &&
                  feedbackItem?.jiraLinks &&
                  feedbackItem.jiraLinks.length > 0 && (
                    <div className={c.attributes}>
                      <h3>Jira Links: </h3>
                      {feedbackItem.jiraLinks.map((link, index) => {
                        const linkId = `jiralink-${index}`;
                        return (
                          <a
                            key={linkId}
                            href={link}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {link.match(regex)?.[0] || 'Invalid Link'}
                          </a>
                        );
                      })}
                    </div>
                  )}
                <div className={c.attributes}>
                  <h3>Bug: </h3>
                  <div>
                    {feedbackItem?.bug === BUG.YES && 'Yes'}
                    {feedbackItem?.bug === BUG.NO && 'No'}
                  </div>
                </div>
                <div className={c.attributes}>
                  <h3>HDR: </h3>
                  <div>
                    {feedbackItem?.hdr === HDR.YES && 'Yes'}
                    {feedbackItem?.hdr === HDR.NO && 'No'}
                  </div>
                </div>
              </div>
              <div className={c.attributeSection}>
                <div className={c.attributeTitle}>
                  <h2>Admin Notes </h2>
                  <Button size="small" variant="text" icon={<Icon.Plus />} />
                </div>

                <div className={c.attributes}>
                  <div>admin notes would go here</div>
                </div>
              </div>

              <div className={c.resolve}>
                <Button size="large" icon={<Icon.Check />}>
                  Resolve Ticket
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IndividualFeedback;
